import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var orderConfirmRoute = [{
  path: "orderConfirm/:id",
  name: "orderConfirm",
  component: function component() {
    return import( /* webpackChunkName: "cart-list" */"./order-confirm.vue");
  }
}];